define.alias("shared/components/shared/social/basic-display-deprecation/wizard", "calendar/components/shared/social/basic-display-deprecation/wizard");